import { createFeatureSelector, createSelector } from "@ngrx/store";
import { DashboardFeatureKey } from "./dashboard.config";
import { IDashboardRootDTO } from "./dashboard.dto";

export const state = createFeatureSelector<IDashboardRootDTO>(DashboardFeatureKey);


export const lastSignedDocuments = createSelector(state, state => state.lastSignedDocuments);
export const bouncedDocuments = createSelector(state, state => state.bouncedDocuments);
export const aboutToExpireContracts = createSelector(state, state => state.expireContracts);
export const mostActiveUsers = createSelector(state, state => state.mostActiveUsers);
export const dashboardSettings = createSelector(state, state => state.dashboardSettings);
export const latestActivities = createSelector(state, state => state.latestActivities);
export const mostUsedTemplates = createSelector(state, state => state.mostUsedTemplates);
export const aboutToExpire = createSelector(state, state => state.aboutToExpire);
export const unreadChatMessages = createSelector(state, state => state.unreadChatMessages);
export const forgottenDocuments = createSelector(state, state => state.forgottenDocuments);
export const autoRenewalOn = createSelector(state, state => state.autoRenewalOn);
export const taskAndReminderSettings = createSelector(state, state => state.taskAndReminderSettings);